module.exports = __webpack_public_path__ + "img/red-triangle-pointed-down.d370cdfd.png";